import { freshGame,landmarks,landmarksForWorld } from '../game.ts'
import { selectedWorld } from '../world/worlds.ts'
import type { GameState } from '../types'
import type { ChallengePlayer } from './types'

// City is a presentation preference, not part of the independent challenge economy.
export function challengeCityState(player:ChallengePlayer,preferences:GameState):GameState {
  return {...freshGame(),worldId:selectedWorld(preferences.worldId),coins:player.coins,levels:[...player.levels],position:player.position,turns:player.turns,rolls:10-player.turns,reducedMotion:preferences.reducedMotion,language:preferences.language,selectedToken:preferences.selectedToken}
}

export function challengeCityEvent(text:string,worldId?:string){
  const names=landmarksForWorld(worldId);
  landmarks.forEach((name,i)=>{text=text.replaceAll(name,names[i])});
  return text
}
